import { FC, useCallback, useMemo, useState } from "react";

import { Icon, Button } from "../../common";
import { UsdKycModal } from "../../modals";

type Props = {
  show?: boolean;
  setShow?: (show: boolean) => void;
  defaultShow?: boolean;
};

export const GetVerifiedUsdBanner: FC<Props> = ({
  show,
  setShow,
  defaultShow,
}) => {
  const [innerShow, setInnerShow] = useState(defaultShow || false);
  const currentShow = useMemo(() => show || innerShow, [show, innerShow]);

  const handleOpen = useCallback(() => {
    if (setShow) {
      setShow(true);
    } else {
      setInnerShow(true);
    }
  }, [setShow]);

  const handleClose = useCallback(() => {
    if (setShow) {
      setShow(false);
    } else {
      setInnerShow(false);
    }
  }, [setShow]);

  return (
    <div className="">
      <Button
        className="px-5"
        contentClassName="flex gap-5"
        variant={Button.variant.PRIMARY}
        onClick={handleOpen}
      >
        <Icon icon="Arrow-right" size={24} className="text-white" disableFill />
        Get USD Verified{" "}
      </Button>

      {currentShow && <UsdKycModal isOpen={currentShow} close={handleClose} />}
    </div>
  );
};
